import { AgeForm } from "./forms/AgeForm";
import { AverageTicketForm } from "./forms/AverageTicketForm";
import { BirthdayForm } from "./forms/BirthdayForm";
import { CustomerDocForm } from "./forms/CustomerDocForm";
import { CustomerEmailForm } from "./forms/CustomerEmailForm";
import { CustomerNameForm } from "./forms/CustomerNameForm";
import { CustomerPhoneForm } from "./forms/CustomerPhoneForm";
import { CustomerTemporalVariationForm } from "./forms/CustomerTemporalVariationForm";
import { DaysWithoutOrderForm } from "./forms/DaysWithoutOrderForm";
import { OrderQuantityForm } from "./forms/OrderQuantityForm";
import { OrderValueForm } from "./forms/OrderValueForm";
import { RfvFrequencyForm } from "./forms/RfvFrequencyForm";
import { TemporalVariationForm } from "./forms/TemporalVariationForm";
import { TotalSpentForm } from "./forms/TotalSpentForm";

export const VariableForms = {
  "o.created_at": TemporalVariationForm,
  "c.count_orders": OrderQuantityForm,
  "o.order_total": TotalSpentForm,
  "c.days_without_order": DaysWithoutOrderForm,
  "c.birthdate": BirthdayForm,
  "c.average_ticket": AverageTicketForm,
  "c.total_orders": OrderValueForm,
  "c.age": AgeForm,
  "c.name": CustomerNameForm,
  "c.email": CustomerEmailForm,
  "c.phone": CustomerPhoneForm,
  "c.doc": CustomerDocForm,
  "c.rfv_frequency": RfvFrequencyForm,
  "c.created_at": CustomerTemporalVariationForm
};
